export interface ProcessStep {
  number: string;
  title: string;
  description: string;
}

export const processSteps: ProcessStep[] = [
  {
    number: "01",
    title: "Choose Your Advisor Platform Tier",
    description: "Select the annual platform license that matches the number of households you serve."
  },
  {
    number: "02", 
    title: "Introduce SeniorThrive to Priority Households",
    description: "Begin with your top 5–10 clients who value proactive aging strategy."
  },
  {
    number: "03",
    title: "Activate Co-Branded Onboarding",
    description: "Clients receive structured onboarding materials aligned with your advisory relationship."
  },
  {
    number: "04",
    title: "Track Engagement and Strengthen Relationships", 
    description: "Monitor household engagement and reinforce your role as a long-term strategic advisor."
  }
];
